const TrashIcon = () => {
    return (
        <i className="fa-solid fa-trash"></i>
    )
}

export default TrashIcon;